<template>
  <div class="card">
    <div class="card-header pb-0">
      <div class="row">
        <div class="col-lg-6 col-7">
          <h6>{{ title }}</h6>
          <!-- <p class="text-sm mb-0" v-html="description"></p> -->
        </div>
        <!-- <div class="col-lg-6 col-5 my-auto text-end">
          <div class="dropdown float-lg-end pe-4">
            <a
              class="cursor-pointer"
              id="dropdownTable"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i class="fa fa-ellipsis-v text-secondary" aria-hidden="true"></i>
            </a>
            <ul
              class="dropdown-menu px-2 py-3 ms-sm-n4 ms-n5"
              aria-labelledby="dropdownTable"
              style=""
            >
              <li>
                <a class="dropdown-item border-radius-md" href="javascript:;">
                  Action
                </a>
              </li>
              <li>
                <a class="dropdown-item border-radius-md" href="javascript:;">
                  AnotherAction
                </a>
              </li>
              <li>
                <a class="dropdown-item border-radius-md" href="javascript:;">
                  SomethingElse
                </a>
              </li>
            </ul>
          </div>
        </div> -->
      </div>
    </div>
    <div class="card-body px-0 pb-2">
      <div class="table-responsive">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th v-for="(heading, index) of headers" :key="index" :class="[
                index === 1 ? 'ps-2' : '',
                index >= 2 ? 'text-center' : '',
              ]" class="text-uppercase text-secondary text-sm font-weight-bolder opacity-7">
                {{ heading }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(
                {
                  label,
                  title,
                  uri,
                  uri_type,
                  id
                },
                  index
              ) of projects" :key="index" 
              :class="{ 'highlight-row': shouldHighlightRow(id) }">
              <td>
                <div class="d-flex px-2 py-1">
                  <!-- <div>
                    <img src="/assets/img/small-logos/logo-jira.svg" class="avatar avatar-sm me-3" alt="Logo" />
                  </div> -->
                  <div class="d-flex flex-column justify-content-center">
                    <p class="mb-0 text-sm text-capitalize">{{ label }}</p>
                  </div>
                </div>
              </td>
              <td>
                <div class="d-flex flex-column justify-content-center">
                  <p class="mb-0 text-sm view-page cursor-pointer" @click="$emit('view-page', { label, uri, uri_type, id })">View Page
                  </p>
                </div>
              </td>
              <td>
                <div class="d-flex flex-column justify-content-center">
                  <p class="mb-0 text-sm text-capitalize">{{ title }}</p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "projectCard",
  props: {
    title: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    headers: {
      type: Array,
      required: true,
    },
    projects: {
      type: Array,
      required: true,
      logo: String,
      title: String,
      members: Array,
      budget: String,
      progress: {
        type: Object,
        percentage: Number,
        color: String,
      },
    },
    highlightRequestNewSkills: {
      type: Boolean,
      default: false,
    },
    highlightSetupWizard: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    shouldHighlightRow(id) {
      if (this.highlightRequestNewSkills && id === "requestNewSkills") return true;
      if (this.highlightSetupWizard && id === "setupWizard") return true;
      return false;
    },
  },
};
</script>
<style scoped>
.view-page {
  color: blue;
}

.view-page:hover {
  text-decoration: underline;
}

.highlight-row {
  background-color: #fdf3b9 !important;
  /* border-left: 4px solid #ffc107 !important; */
  font-weight: 500;
}

.highlight-row:hover {
  background-color: #ffe69c !important;
}
</style>
